<template>
  <div
    class=""
    :style="{
      'font-size': size,
      'text-align': align,
      display: display,
      height: height,
      border: border,
      color: color,
      'border-radius': radius,
      'background-color': background,
    }"
    @click="openUpload()"
  >
    <div v-if="file === null" style="padding-top: 5px; cursor: pointer">
      {{ label }}
    </div>

    <div style="padding-top: 5px; cursor: pointer">
      <div class="w-full" v-if="placeholder">
        {{ placeholder.substr(0, 20) }}
        <span v-if="placeholder.length > 20">...</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  bodyClass: "profile-page",

  components: {},
  props: {
    icon: {
      type: Object,
      default: null
    },
    label: {
      type: String,
      default: null
    },
    display: {
      type: String,
      default: "block"
    },
    background: {
      type: String,
      default: "black"
    },
    border: {
      type: String,
      default: "none"
    },
    align: {
      type: String,
      default: "center"
    },
    size: {
      type: String,
      default: "16px"
    },
    radius: {
      type: String,
      default: "0px"
    },
    height: {
      type: String,
      default: "90px"
    },
    color: {
      type: String,
      default: "#fff"
    }
  },

  data() {
    return {
      file: null,
      url: null,
      placeholder: null
    };
  },

  created() {},

  methods: {
    openUpload() {
      const input = document.createElement("input");
      input.type = "file";
      input.setAttribute("accept", "image/*");
      input.onchange = e => {
        this.file = e.target.files[0];
        this.url = URL.createObjectURL(this.file);
        this.placeholder = e.target.files[0].name;
        this.$emit("info", this.file);
      };
      input.click();
    }
  }
};
</script>

<style lang="scss" scoped></style>
